const testimonials = [
  {
    name: "Christine L.",
    location: "Garden District, New Orleans",
    rating: 5,
    text: "Booked a last-minute Caribbean cruise from the Port of New Orleans and my husband realized his passport expired two weeks before departure. Called Fast Passport Center on a Monday, shipped documents overnight from uptown, and had his renewed passport by Thursday. We sailed Saturday morning. They saved our anniversary trip and were incredibly calm and professional through the whole process.",
    service: "Emergency Renewal",
  },
  {
    name: "Dr. Marcus T.",
    location: "Tulane University, New Orleans",
    rating: 5,
    text: "I am a professor at Tulane and got invited to present at a conference in London with about ten days notice. My passport had expired during the pandemic when I wasn't traveling. Fast Passport Center reviewed my documents the same day I submitted, processed everything in six business days, and I made my flight to London with three days to spare. Cannot say enough good things.",
    service: "Passport Renewal",
  },
  {
    name: "Antoine & Nadia B.",
    location: "Metairie, Louisiana",
    rating: 5,
    text: "Our daughter got accepted to a study abroad program at the Sorbonne and we had about three weeks to get her first passport. Fast Passport Center walked us through the acceptance clerk process, told us exactly which post office to visit, what forms to bring, and the checklist was perfect. Had her passport back in eight business days. She made orientation in Paris with a week to spare.",
    service: "New Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function NewOrleansTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What New Orleans &amp; Southeast Louisiana Travelers Say About Our Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from New Orleans, Metairie, and Tulane travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}